import {Game} from "./model/Game.ts";
import {Play, secondsToMinutes} from "./model/Play.ts";
import {Athlete, Position} from "./model/Athlete.ts";
import {Team} from "./model/Team.ts";
import * as React from 'react';
import {useState} from 'react';
import './LineupPmGrid.css';
import {Lineup, lineupz} from "./lineupsmaker.ts";
import {Line, LineChart, ReferenceLine, ResponsiveContainer, Tooltip, TooltipProps, XAxis, YAxis} from 'recharts';
import {createPortal} from "react-dom";

interface LineupPmGridProps {
    game: Game
    plays: Play[]
    players: Athlete[]
    homeTeam: Team,
    awayTeam: Team
    zoomLevel: number
}

export default function LineupPmGrid({game, plays, players, homeTeam, awayTeam, zoomLevel}: LineupPmGridProps) {

    console.log("homeTeam", homeTeam, "awayTeam", awayTeam, "game", game, "plays", plays, "players", players)
    return (
        <>
            <table className="bottom_border">
                <tbody>
                <tr>
                    <td className="team"
                        style={{
                            backgroundColor: `#${homeTeam.alternateColor}`,
                            color: `#${homeTeam.color}`,
                        }}
                    >
                        <div className={"vertical"} style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <img style={{height: "3em"}} src={homeTeam.logo} alt={`${homeTeam.shortDisplayName} logo`}/>
                            <h2>{homeTeam.shortDisplayName}</h2>
                        </div>
                    </td>
                    <td style={{width: 100, padding: 0}}>
                        <table style={{margin: 0, borderCollapse: 'collapse'}}>
                            <tbody>
                            {[...Array(5)].map((_, index) => (
                                <tr key={index + 1}>
                                    <td className={"align-right, bottom_border"}>{index + 1}</td>
                                </tr>
                            ))}

                            <tr>
                                <td className={"align-right, bottom_border"} style={{
                                    background: 'linear-gradient(to top right, #FE191D 0%, #FE191D 50%, #12FE53 50%, #12FE53 100%)'
                                }}>+-/min</td>
                            </tr>
                            </tbody>
                        </table>
                    </td>
                    <td style={{width: 100, padding: 0}}>
                        <Grid id="top" game={game} plays={plays} home={true} reversed={false} players={players}
                              zoomLevel={zoomLevel}/>
                    </td>
                </tr>
                <tr>
                    <td colSpan={2} style={{verticalAlign: 'middle'}}>
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center', height: '100%'}}>
                            <div style={{fontSize: '1.2em', fontWeight: 'bold'}}>Timeline →</div>
                            <div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                                <div style={{fontSize: '0.8em', fontStyle: 'italic', color: 'green'}}>Score differential</div>
                                <div style={{width: '10px', height: '1px', backgroundColor: 'green'}}></div>
                            </div>
                        </div>
                    </td>
                    <td style={{padding: 0}}><Timeline game={game} plays={plays} players={players}
                                                       zoomLevel={zoomLevel}/></td>
                </tr>
                <tr>
                    <td className="team"
                        style={{
                            backgroundColor: `#${awayTeam.alternateColor}`,
                            color: `#${awayTeam.color}`,
                        }}
                    >
                        <div className={"vertical"} style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <img style={{height: "3em"}} src={awayTeam.logo} alt={`${awayTeam.shortDisplayName} logo`}/>
                            <h2>{awayTeam.shortDisplayName}</h2>
                        </div>
                    </td>
                    <td style={{width: 100, padding: 0}}>
                        <table style={{margin: 0, border: 'none', borderCollapse: 'collapse'}}>
                            <tbody>
                            <tr>
                                <td className={"align-right, bottom_border"} style={{
                                    background: 'linear-gradient(to top right, #FE191D 0%, #FE191D 50%, #12FE53 50%, #12FE53 100%)'
                                }}>+-/min</td>
                            </tr>

                            {[...Array(5)].map((_, index) => (
                                <tr key={index + 1}>
                                    <td className={"align-right, bottom_border"}>{index + 1}</td>
                                </tr>
                            )).reverse()}

                            </tbody>
                        </table>
                    </td>
                    <td style={{width: 100, padding: 0}}>
                        <Grid id="bottom" game={game} plays={plays} home={false} reversed={true} players={players}
                              zoomLevel={zoomLevel}/>
                    </td>
                </tr>
                </tbody>
            </table>
        </>
    );
}

export function ColorKey() {
    const [isExpanded, setIsExpanded] = useState(false);

    const positions = [
        {name: 'PG', fullName: 'Point Guard', colors: pgColors},
        {name: 'SG', fullName: 'Shooting Guard', colors: sgColors},
        {name: 'SF', fullName: 'Small Forward', colors: sfColors},
        {name: 'PF', fullName: 'Power Forward', colors: pfColors},
        {name: 'C', fullName: 'Center', colors: cColors}
    ];

    return (
        <div style={{
            padding: '4px',
            fontSize: '10px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            backgroundColor: '#f9f9f9'
        }}>
            <h2
                onClick={() => setIsExpanded(!isExpanded)}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e0e0e0'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
            >
                Color Key  <span style={{
                fontSize: '12px',
                transition: 'transform 0.2s',
                display: 'inline-block',
            }}>
                    {isExpanded ? '▼' : '▶'}
                </span>
            </h2>
            {isExpanded && (
                <>
                    <div style={{
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        padding: '4px',
                        marginBottom: '8px',
                        backgroundColor: '#fff53b'

                    }}><div style={{
                        marginBottom: '4px',
                        fontSize: '14px',
                        fontWeight: 'bold',

                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center'
                    }}>
                        1 color represents 1 player
                    </div>
                        (so you can follow a player throughout the game)
                    </div>
                    <div style={{
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        padding: '4px',
                        marginBottom: '8px',
                        backgroundColor: '#fff'
                    }}>
                        <div style={{marginBottom: '4px', fontSize: '14px', textDecoration: 'underline'}}>Color ranges by position:</div>
                        {positions.map(pos => (
                            <div key={pos.name} style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                marginBottom: '4px'
                            }}>
                                <div style={{
                                    fontWeight: 'bold',
                                    width: '80px',
                                    textAlign: 'right'
                                }}>
                                    {pos.fullName}
                                </div>
                                <div style={{
                                    display: 'flex',
                                    gap: '2px',
                                }}>
                                    {pos.colors.map((color, idx) => (
                                        <div key={idx} style={{
                                            width: '15px',
                                            height: '15px',
                                            backgroundColor: color,
                                            border: '1px solid #999',
                                            borderRadius: '2px'
                                        }}/>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div style={{
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        padding: '4px',
                        marginBottom: '8px',
                        backgroundColor: '#fff'
                    }}>

                        <div key='+-' style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            marginBottom: '4px'
                        }}>

                            <div style={{marginTop: '10px', width: '80px', fontWeight: 'bold'}}>+/- per min:</div>
                            <PmColorScale/>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

function PmColorScale() {
    const values = Array.from({length: 11}, (_, i) => i - 5); // -5 to 5

    return (
        <div>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                fontSize: '8px',
                fontWeight: 'bold',
                marginBottom: '2px'
            }}>
                <div>Bad</div>
                <div>Good</div>
            </div>
            <div style={{display: 'flex', gap: '0px'}}>
                {values.map(value => (
                    <div key={value} style={{
                        width: '15px',
                        height: '15px',
                        backgroundColor: getPMperSecColor(value, 5),
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: '8px',
                        color: getContrastColor(getPMperSecColor(value, 5))
                    }}/>
                ))}
            </div>
        </div>
    );
}

function Grid(props: {
    game: Game,
    plays: Play[],
    players: Athlete[],
    home: boolean,
    reversed: boolean,
    id: string
    zoomLevel: number
}) {
    const lineups = lineupz(props.game, props.plays, props.players, props.home);
    const playerColors = playerColorz([...new Set(lineups.flatMap(lineup => lineup.players))])
    const array2d = array2dz(lineups)
    const columnWidths = columnWidthz(lineups, props.zoomLevel)

    const range = props.reversed
        ? [...Array(array2d.length).keys()].reverse()
        : [...Array(array2d.length).keys()];
    // Sum up column widths:
    let totalWidth = columnWidths.size > 0 ? Array.from(columnWidths.values()).reduce((acc, w) => acc + w) : 0;
    console.log("lineups", lineups, "columnWidths", columnWidths, "totalWidth", totalWidth)

    function playersKey(lineup: Lineup): string {
        return lineup.players
            .map(player => player.id)
            .sort()
            .join(',');
    }

    const sameLineupIndices = lineups.reduce((acc, lineup, currentIndex) => {
        // Create a key by sorting and joining player IDs to ensure consistent matching
        const key = playersKey(lineup);

        if (!acc.has(key)) {
            acc.set(key, []);
        }
        acc.get(key)!.push(currentIndex);
        return acc;
    }, new Map<string, number[]>());

    const [hoveredLineupIndex, setHoveredLineupIndex] = useState<number | null>(null);
    const [tooltip, setTooltip] = useState({x: 0, y: 0, side: "right" as "left" | "right"});
    const handleMouseEnter = (index: number) => {
        setHoveredLineupIndex(index);
    };
    const handleMouseLeave = () => {
        setHoveredLineupIndex(null);
    };

    const handleMouseMove = (e: React.MouseEvent<HTMLTableCellElement>) => {
        const mouseX = e.clientX;
        const mouseY = e.clientY;
        const tooltipWidth = 200; // Estimate or measure the actual tooltip width

        // Space available on the right of the cursor
        const spaceToRight = window.innerWidth - mouseX;

        // Decide whether to flip
        let side: "left" | "right" = "right";
        if (spaceToRight < tooltipWidth + 20) {
            // If not enough space on the right, flip to the left
            side = "left";
        }

        setTooltip({x: mouseX, y: mouseY, side});
    };

    return (
        <div className="table-wrapper">
            <table id={props.id} width={totalWidth} className="real-table">
                <colgroup>
                    {Array.from(columnWidths.values()).map(width => (
                        <col span={1} style={{width}}/>
                    ))}
                </colgroup>
                <tbody>
                {props.reversed ? (<PMPerSecRow lineups={lineups} home={props.home}/>) : null}
                {range.map((row) => {
                    const pairs = array2d[row];
                    return (
                        <tr key={row}>
                            {pairs.map((pair, col) => {
                                if (!pair) {
                                    // If pair is null, just return an empty cell, or skip entirely.
                                    return
                                }
                                const [athlete, span] = pair;
                                const backgroundColor = playerColors.get(athlete)
                                return (
                                    <td
                                        key={col}
                                        style={{
                                            backgroundColor: `${backgroundColor}`,
                                            color: `${getContrastColor(backgroundColor)}`
                                        }}
                                        colSpan={span}
                                    >
                                        {athlete.shortName}
                                    </td>
                                );
                            })}
                        </tr>
                    );
                })}
                {!props.reversed ? (<PMPerSecRow lineups={lineups} home={props.home}/>) : null}
                </tbody>
            </table>
            <table className="overlay-table" width={totalWidth}>
                <colgroup>
                    {Array.from(columnWidths.values()).map(width => (
                        <col span={1} style={{width}}/>
                    ))}
                </colgroup>

                <tbody>
                <tr>
                    {lineups.map((lineup, index) => {
                        const otherIndices = hoveredLineupIndex != null
                            ? sameLineupIndices.get(playersKey(lineups[hoveredLineupIndex])) ?? []
                            : [];

                        return <td
                            key={index}
                            className={`
                              ${otherIndices.includes(index) ? "tooltip-highlight" : "colon"}
                            `}
                            onMouseEnter={() => handleMouseEnter(index)}
                            onMouseLeave={handleMouseLeave}
                            onMouseMove={handleMouseMove}
                        />
                    })}
                </tr>
                </tbody>
            </table>
            {/* Render the tooltip in the Portal */}
            {hoveredLineupIndex !== null && (
                <Tooltips x={tooltip.x} y={tooltip.y} side={tooltip.side}>
                    <div>
                        <strong>Start:</strong> {lineups[hoveredLineupIndex].timeStart.toString()}
                    </div>
                    <div>
                        <strong>End:</strong> {lineups[hoveredLineupIndex].timeEnd.toString()}
                    </div>
                </Tooltips>
            )}
        </div>
    )
}

function Tooltips({x, y, side, children}: {
    x: number;
    y: number;
    side: "left" | "right";
    children: React.ReactNode;
}) {
    // Offset the tooltip a bit so it's not directly under the cursor
    const offset = 10;

    // Compute left/right positions based on `side`
    const style: React.CSSProperties = {
        position: "fixed",
        top: y + offset,
        // if side === "right", position via `left`. If side === "left", position via `left` but offset negative.
        left: side === "right" ? x + offset : "auto",
        // or position via `right` if side === "left"
        right: side === "left" ? window.innerWidth - x + offset : "auto",
        background: "white",
        border: "1px solid #ccc",
        padding: "8px",
        pointerEvents: "none",
        zIndex: 9999
    };

    return createPortal(
        <div style={style}>
            {children}
        </div>,
        document.body
    );
}

function PMPerSecRow(props: {
    lineups: Lineup[],
    home: boolean,
}) {
    return (
        <tr>
            {props.lineups.map((lineup, index) => {

                const plusMinus = props.home
                    ? (lineup.homePointsAtEnd - lineup.homePointsAtStart) - (lineup.awayPointsAtEnd - lineup.awayPointsAtStart)
                    : (lineup.awayPointsAtEnd - lineup.awayPointsAtStart) - (lineup.homePointsAtEnd - lineup.homePointsAtStart)
                const plusMinusPerSecond = plusMinus / lineup.length * 60

                const pmString = plusMinusPerSecond.toFixed(2).toString().replace(/^0\./, ".")
                const backgroundColor = getPMperSecColor(plusMinusPerSecond)

                return (<td className={"bottom_border"} key={index}
                            style={{
                                backgroundColor: `${backgroundColor}`,
                                color: `${getContrastColor(backgroundColor)}`
                            }}>{pmString}</td>)
            })}
        </tr>
    )
}

function PlusMinusRow(props: {
    lineups: Lineup[],
    home: boolean,
}) {
    return (<tr>
        {props.lineups.map((lineup, index) => {
            const plusMinus = props.home
                ? (lineup.homePointsAtEnd - lineup.homePointsAtStart) - (lineup.awayPointsAtEnd - lineup.awayPointsAtStart)
                : (lineup.awayPointsAtEnd - lineup.awayPointsAtStart) - (lineup.homePointsAtEnd - lineup.homePointsAtStart)
            const pmString = (plusMinus > 0) ? "+" + plusMinus : plusMinus.toString()
            return (<td className={"bottom_border"} key={index}>{pmString}</td>)
        })}
    </tr>)
}

function TimeLengthRow(props: {
    lineups: Lineup[],
}) {
    return (<tr>
        {props.lineups.map((lineup, index) => {
            return (<td className={"bottom_border"} key={index}>{secondsToMinutes(lineup.length)}</td>)
        })}
    </tr>)
}

function Timeline(props: {
    game: Game,
    plays: Play[],
    players: Athlete[]
    zoomLevel: number
}) {

    const lineups = lineupz(props.game, props.plays, props.players, true);
    const totalSeconds = lineups.reduce((acc, l) => acc + l.length, 0);

    const regularQuarter = 12 * 60
    const overtimeQuarter = 5 * 60


    let ticks: React.JSX.Element[] = []
    let afterEndOfQuarter = false
    for (let secs = 0; secs <= Math.floor(totalSeconds); secs += 60) {
        const endOfQuarter =
            secs <= regularQuarter * 4
                ? secs % regularQuarter === 0
                : secs % overtimeQuarter === 0;

        const quarter =
            secs < regularQuarter * 4
                ? `Q${Math.floor(secs / regularQuarter) + 1}`
                : (secs === regularQuarter * 4 && totalSeconds === secs)
                    ? ""
                    : "OT";

        ticks.push((
            <div style={{
                paddingLeft: secs == 0 ? 0 : afterEndOfQuarter ? secondsToDp(60, props.zoomLevel) - 1 - 21.667 : secondsToDp(60, props.zoomLevel) - 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <div
                    style={{
                        height: endOfQuarter ? '100%' : '30%',
                        width: '1px',
                        backgroundColor: 'black'
                    }}
                />
                {endOfQuarter && (
                    <div style={{paddingLeft: 2, fontFamily: "monospace", fontWeight: "bold", fontSize: "large"}}>
                        {quarter}
                    </div>
                )}
            </div>
        ));
        endOfQuarter ? afterEndOfQuarter = true : afterEndOfQuarter = false
    }

    const chartData = props.plays
        .filter(play => play.scoringPlay || play.type == "End Game")
        .map(play => {
            return {
                x: secondsToDp(play.time.secondsElapsed(), props.zoomLevel),
                y: play.homeScore - play.awayScore,
                time: play.time.toString()
            };
        })

    chartData.unshift({x: 0, y: 0, time: "Q1 12:00"})
    console.log('chartData:', chartData, "totalSeconds", totalSeconds);

    const CustomTooltip = ({active, payload,}: TooltipProps<number, string>) => {
        if (active && payload && payload.length) {
            const {y, time} = payload[0].payload;
            return (
                <div style={{
                    background: 'white',
                    borderRadius: '4px',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                }}>
                    <div>{y > 0 ? `+${y}` : y}</div>
                    <div>{time}</div>
                </div>
            );
        }
        return null;
    };

    return <div className="overlay-containter">
        <div style={{
            display: 'flex',
            backgroundColor: 'yellow',
            height: 40,
        }}>
            {ticks}
        </div>
        <div className="overlay-content">
            <ResponsiveContainer width="100%" height={40}>
                <LineChart data={chartData} height={40} margin={{top: 0, right: 0, bottom: 0, left: 0}}>
                    <XAxis dataKey="x" hide height={0} domain={['dataMin', 'dataMax']} type="number"/>
                    <YAxis
                        type={"number"}
                        hide={true}
                        domain={['dataMin', 'dataMax']}
                        padding={{top: 0, bottom: 0}}
                    />
                    <ReferenceLine y={0} stroke="blue"/>
                    <Tooltip
                        content={<CustomTooltip/>}
                        position={{y: 0}}
                        cursor={false}
                    />
                    <Line type="stepAfter" dataKey="y" stroke="green" dot={false} activeDot={{
                        r: 4,
                        fill: 'green',
                        stroke: 'white',
                        strokeWidth: 2
                    }}/>
                </LineChart>
            </ResponsiveContainer>
        </div>

    </div>
}


/********************************************
 *  TYPE DEFINITIONS / HELPERS
 ********************************************/


export type Dp = number;

export function secondsToDp(numSeconds: number | number[], zoomLevel: number): Dp {
    if (typeof numSeconds === "number") {
        return numSeconds * zoomLevel;
    }
    return 0;
}

export function playerColorz(players: Athlete[]): Map<Athlete, string> {
    let pgCount = 0;
    let sgCount = 0;
    let sfCount = 0;
    let pfCount = 0;
    let cCount = 0;

    const map = new Map<Athlete, string>();

    for (const ath of players) {
        let chosenColor

        switch (ath.position) {
            case Position.PG:
                chosenColor = pgColors[++pgCount % pgColors.length];
                break;
            case Position.SG:
                chosenColor = sgColors[++sgCount % sgColors.length];
                break;
            case Position.SF:
                chosenColor = sfColors[++sfCount % sfColors.length];
                break;
            case Position.PF:
                chosenColor = pfColors[++pfCount % pfColors.length];
                break;
            case Position.C:
                chosenColor = cColors[++cCount % cColors.length];
                break;
            case Position.F:
                chosenColor = pfColors[++pfCount % pfColors.length];
                break;
            case Position.G:
                chosenColor = sgColors[++sgCount % sgColors.length];
                break;
            case Position.NA:
            default:
                chosenColor = "rgb(255,255,255)"
                break;
        }

        map.set(ath, chosenColor);
    }

    return map;
}

function rgbStringToObject(rgb: string): { red: number, green: number, blue: number, alpha: number } {
    const match = rgb.match(/^rgba?\(([0-9]+),\s*([0-9]+),\s*([0-9]+)(?:,\s*([0-9.]+))?\)$/);
    if (!match) return {red: 0, green: 0, blue: 0, alpha: 0}//throw new Error(`Invalid RGB string: ${rgb}`);
    return {
        red: parseInt(match[1], 10),
        green: parseInt(match[2], 10),
        blue: parseInt(match[3], 10),
        alpha: match[4] ? Number(match[4]) : 1,
    };
}

function getContrastColor(rgbString?: string): string {
    if (typeof rgbString === 'undefined') {
        // Return black if no valid color provided
        return "rgba(0, 0, 0, 1)";
    }
    const color = rgbStringToObject(rgbString);

    const luminance = (0.299 * color.red) + (0.587 * color.green) + (0.114 * color.blue);
    return (luminance > 128) ? 'black' : 'white';
}

/**
 * Returns an RGB color string (e.g. "rgb(255,128,0)")
 */
function getPMperSecColor(value: number, max: number = 9.0): string {
    let power = Math.abs(value) / max;
    if (power > 1) {
        power = 1.0;
    }

    const H = value <= 0 ? 0 : 140;
    // Saturation = power
    const S = power;
    // Brightness = 1
    const B = 1;

    try {
        const {r, g, b} = hsvToRgb(H, S, B);
        return `rgb(${r}, ${g}, ${b})`;
    } catch (e) {
        console.error(e);
        console.log(`value: ${value}, max: ${max}, power: ${power}, H: ${H}, S: ${S}, B: ${B}`);
        throw e;
    }
}

/**
 * Convert HSV color values to an {r, g, b} object.
 * H is in [0..360], S and V in [0..1].
 */
function hsvToRgb(h: number, s: number, v: number): { r: number; g: number; b: number } {
    const c = v * s;
    const x = c * (1 - Math.abs((h / 60) % 2 - 1));
    const m = v - c;

    let rPrime = 0;
    let gPrime = 0;
    let bPrime = 0;

    if (h < 60) {
        rPrime = c;
        gPrime = x;
    } else if (h < 120) {
        rPrime = x;
        gPrime = c;
    } else if (h < 180) {
        gPrime = c;
        bPrime = x;
    } else if (h < 240) {
        gPrime = x;
        bPrime = c;
    } else if (h < 300) {
        rPrime = x;
        bPrime = c;
    } else {
        rPrime = c;
        bPrime = x;
    }

    return {
        r: Math.round((rPrime + m) * 255),
        g: Math.round((gPrime + m) * 255),
        b: Math.round((bPrime + m) * 255),
    };
}

const pgColors = [
    "rgb(255, 255, 0)",
    "rgb(255, 144, 0)",
    "rgb(255, 227, 0)",
    "rgb(255, 116, 0)",
    "rgb(255, 199, 0)",
    "rgb(255, 88, 0)",
    "rgb(255, 172, 0)",
];

const sgColors = [
    "rgb(116, 198, 157)",
    "rgb(82, 183, 136)",
    "rgb(149, 213, 178)",
    "rgb(64, 145, 108)",
    "rgb(183, 228, 199)",
    "rgb(45, 106, 79)",
    "rgb(216, 243, 220)",
    "rgb(27, 67, 50)",
];

const sfColors = [
    "rgb(230, 184, 162)",
    "rgb(138, 90, 68)",
    "rgb(214, 159, 126)",
    "rgb(176, 125, 98)",
    "rgb(222, 171, 144)",
    "rgb(195, 142, 112)",
    "rgb(237, 196, 179)",
    "rgb(119, 73, 54)",
];

const pfColors = [
    "rgb(227, 242, 253)",
    "rgb(187, 222, 251)",
    "rgb(144, 202, 249)",
    "rgb(100, 181, 246)",
    "rgb(30, 136, 229)",
    "rgb(21, 101, 192)",
    "rgb(13, 71, 161)",
];

const cColors = [
    "rgb(49, 0, 85)",
    "rgb(139, 47, 201)",
    "rgb(171, 81, 227)",
    "rgb(74, 10, 119)",
    "rgb(189, 104, 238)",
    "rgb(210, 131, 255)",
    "rgb(104, 24, 165)",
    "rgb(220, 151, 255)",
];

/********************************************
 * ATHLETE SORT
 ********************************************/

// Kotlin: a Comparator<Athlete>


// The logic lumps consecutive identical players in a single cell with a repeat count
export function array2dz(lineups: Lineup[]): Array<Array<[Athlete, number] | null>> {
    return [...Array(5)].map((_, rowIndex) => {
        const rowSlice = lineups.map(lineup => lineup.players[rowIndex]);
        // We'll then process from right to left, counting consecutive duplicates
        const newList: Array<[Athlete, number] | null> = [];

        let repeatCounter = 1;
        for (let i = rowSlice.length - 1; i >= 0; i--) {
            if (i > 0 && rowSlice[i] === rowSlice[i - 1]) {
                // same as prev -> skip
                newList.push(null);
                repeatCounter++;
            } else {
                // new chunk
                newList.push([rowSlice[i], repeatCounter]);
                repeatCounter = 1;
            }
        }
        return newList.reverse();
    });
}

export function columnWidthz(lineups: Lineup[], zoomLevel: number): Map<Lineup, number> {
    const totalTime = lineups.reduce((acc, l) => acc + l.length, 0);
    console.log("totalTime", totalTime)

    const map = new Map<Lineup, number>();

    for (const lineup of lineups) {
        map.set(lineup, secondsToDp(lineup.length, zoomLevel))
    }
    return map;
}
